<template lang="html">
  <div id="results-page-s1">

    <section class="placed-backg banner-section jobs">
      <div class="inside">
        <h1>Empleos Disponibles</h1>
      </div>
    </section>

    <!-- <section class="container search-form-section">
      <div class="content">
        <search-form-component></search-form-component>
      </div>
    </section> -->

    <section class="container results-section">
      <div class="row">

        <!-- Columna izquierda con filtros -->
        <div class="col-lg-3 col-filters">
          <div class="bg-filters-mob" v-bind:class="{ active : isFiltersActive }" @click="isFiltersActive = false;"></div>

          <div class="filters-container" v-bind:class="{ active : isFiltersActive }">
            <div class="box-column-title">Personalizar búsqueda <a class="btn-close" @click="isFiltersActive = false;"><i class="fas fa-chevron-left"></i></a></div>

            <div class="main-box">

              <div class="box-filters-group">
                <h5 class="group-title">Busqueda</h5>

                <div class="box-options">
                  <b-form-group>
                    <b-form-input
                      v-model="searchForm.keywords"
                      type="text"
                      placeholder="Puesto o palabras clave"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Ubicación</h5>

                <div class="box-options">
                  <b-form-group label="Estado:" label-for="i-estado">
                    <b-form-select id="i-estado" v-model="searchForm.state" v-bind:class="{ empty : !searchForm.state }">
                      <b-form-select-option :value="null">Seleccionar Estado</b-form-select-option>
                      <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group label="Ciudad:" label-for="i-ciudad">
                    <b-form-select id="i-ciudad" v-model="searchForm.town" v-bind:class="{ empty : !searchForm.town }">
                      <b-form-select-option :value="null">Seleccionar Ciudad</b-form-select-option>
                      <b-form-select-option :value="town.id" v-for="town in townsOpcs" :key="town.id">{{town.name}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <!-- <div class="box-btn">
                    <b-button type="submit" class="btn-squ-1 lg">buscar</b-button>
                  </div> -->
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Área de Trabajo</h5>

                <div class="box-options">
                  <b-form-group label-for="i-estado">
                    <b-form-select id="i-estado" v-model="searchForm.category" v-bind:class="{ empty : !searchForm.category }">
                      <b-form-select-option :value="null">Seleccionar Área</b-form-select-option>
                      <b-form-select-option :value="category.id" v-for="category in categoriesOpcs" :key="category.id">{{category.nombre}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Tipo de Trabajo</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaType }">
                    <b-form-checkbox-group class="checkbox-radio-group"
                      v-model="searchForm.tipo_puesto"
                      :aria-describedby="ariaType"
                      name="tipo-trabajo">
                      <b-form-checkbox value="tiempo_completo">Tiempo completo</b-form-checkbox>
                      <b-form-checkbox value="medio_completo">Medio tiempo</b-form-checkbox>
                      <b-form-checkbox value="temporal">Temporal</b-form-checkbox>
                      <b-form-checkbox value="freelance">Freelance</b-form-checkbox>
                      <b-form-checkbox value="home_office">Home office</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Habilidades</h5>

                <div class="box-options">
                  <b-form-group label-for="i-estado">
                    <b-form-select id="i-estado" v-model="searchForm.ability" v-bind:class="{ empty : !searchForm.category }">
                      <b-form-select-option :value="null">Selecciona una habilidad</b-form-select-option>
                      <b-form-select-option :value="ability.id" v-for="ability in abilitiesOpcs" :key="ability.id">{{ability.nombre}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>


              <div class="box-filters-group">
                <h5 class="group-title">Sueldo</h5>

                <div class="box-options">
                  <b-form-group class="mb-3" v-slot="{ ariaSueldoType }">
                    <b-form-checkbox-group class="checkbox-radiobutton-group">
                      <b-form-radio v-model="searchForm.sueldoType" :aria-describedby="ariaSueldoType" name="sueldoType" value="mensual">Mensual</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldoType" :aria-describedby="ariaSueldoType" name="sueldoType" value="quincenal">Quincenal</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldoType" :aria-describedby="ariaSueldoType" name="sueldoType" value="semanal">Semanal</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>

                  <b-form-group v-slot="{ ariaSueldo }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="1000">- 1,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="1000-3000">1,000 - 3,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="3001-6000">3,001 - 6,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="6001-8000">6,001 - 8,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="8001-10000">8,001 - 10,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="10001-15000">10,001 - 15,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="15001-20000">15,001 - 20,000</b-form-radio>
                      <b-form-radio v-model="searchForm.sueldo" :aria-describedby="ariaSueldo" name="sueldo" value="20000">+ 20,000</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <div class="box-filters-group">
                <h5 class="group-title">Publicado</h5>

                <div class="box-options">
                  <b-form-group v-slot="{ ariaPub }">
                    <b-form-checkbox-group class="checkbox-radio-group">
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="0">Hace 1 hora</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="1">Últimas 24 horas</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="2">Últimos 7 días</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="3">Últimos 14 días</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="4">Último mes</b-form-radio>
                      <b-form-radio v-model="searchForm.publicado" :aria-describedby="ariaPub" name="publicado" value="5">Más de un mes</b-form-radio>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <!-- <div class="box-company">
                <div class="box-title">
                  Empresa Elite
                </div>

                <div class="box">
                  <div class="col col-jobs">
                    <h5>12 Vacantes</h5>

                    <ul>
                      <li>Recepción</li>
                      <li>Médicos especialitas</li>
                      <li>Intendencia</li>
                      <li>Telemarketing</li>
                    </ul>

                    <router-link class="trans-250 link-profile" to="/empresas/1">VER PERFIL</router-link>
                  </div>

                  <div class="col col-logo">
                    <img src="public/images/pages/jobs/logo-1.png">
                  </div>
                </div>
              </div> -->

            </div>
          </div>
        </div>
        <!--  -->

        <!-- Columna derecha con resultados de empleos -->
        <div class="col-lg-9 col-results">
          <div class="row top-container">
            <div class="col-12 d-lg-none col-mobile-filter">
              <a class="btn-cur-1" @click="isFiltersActive = !isFiltersActive"><i class="fas fa-filter"></i> <span v-if="!isFiltersActive">Mostrar</span> <span v-if="isFiltersActive">Ocultar</span> filtros avanzados</a>
            </div>

            <div class="col-lg-6 col-count">
              <h4>{{jobs.length}} Trabajos encontrados</h4>
              <p>mostrados  1 - {{pagination.per_page}} en esta página</p>
            </div>

            <div class="col-lg-6 col-options" v-if="type_get == 0">
              <div class="box">
                <span>Ordenar por</span>
                <b-form-select v-model="pagination.order">
                  <b-form-select-option value="0">Más recientes</b-form-select-option>
                  <b-form-select-option value="1">Alfabeto</b-form-select-option>
                </b-form-select>
              </div>

              <div class="box">
                <span>Resultados</span>
                <b-form-select v-model="pagination.per_page">
                  <b-form-select-option value="50">50 por página</b-form-select-option>
                  <!-- <b-form-select-option value="20">20 por página</b-form-select-option> -->
                </b-form-select>
              </div>
            </div>
          </div>

          <div class="row results-container">
            <div class="col-12 col-jobs-s2" v-for="(job, hjbInx) in jobs" :key="'hjbInx-'+hjbInx">
              <router-link class="box" :to="'/empleos/'+job.id">
                <div class="box-urgent" v-if="job.urgente_regular == 'urgente'"><span>URGENTE</span></div>
                <div class="box-urgent" v-else-if="job.urgente_regular == 'regular'" style="background-color:#0e447b"><span>REGULAR</span></div>

                <div class="col col-logo">
                  <img :src="job.empresa_imageUrl">
                </div>

                <div class="col col-info">
                  <h4 class="title">{{ job.nombre }}</h4>
                  <div class="best-companies" v-if="job.best"><span><i class="fas fa-star"></i> Mejores Empresas</span></div>
                  <h5><span class="company">{{ job.empresa }}</span> <i class="loc-icon"></i><span class="location">{{ job.ciudad }},{{ job.estado }}.</span></h5>
                  <h5 class="extra" v-if="job.hace_dias != 0">Publicado hace {{job.hace_dias}} días. | {{job.area}}</h5>
                  <h5 class="extra" v-else>Publicado Hoy. | {{job.area}}</h5>

                </div>

                <div class="col-12 col-line">
                  <hr />
                </div>

                <div class="col col-salary">
                  <p>{{job.sueldo}} / {{job.periodo}}</p>
                </div>

                <div class="col col-time">
                  <h6 class="date">{{job.decha}}</h6>
                  <span class="type completo" v-bind:style="{ backgroundColor: job.typeColor }">{{ job.type }}</span>
                </div>
              </router-link>
            </div>
          </div>

          <div class="row pagination-container">
            <div class="col-12 col-pagination">
              <b-pagination
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.per_page"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </section>

  </div>
</template>

<script>
import searchFormComponent from '../shared/search-form-component.vue';
export default {
  data(){
    return{
      isFiltersActive: false,
      type_get:0,

      jobs: [
       /* { img: 'public/images/pages/jobs/logo-1.png', best: false, title: 'Ejecutivo de Cuenta', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-2.png', best: false, title: 'Agente Inmobiliario', company: 'Blue Capital', type: 'Freelance', typeColor: '#d8248e' },
        { img: 'public/images/pages/jobs/logo-3.png', best: true, title: 'Distribuidor', company: 'Café Colibrí Artesanal', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-1.png', best: false, title: 'Recepcionista', company: 'Insumos Quirúrgicos', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-4.png', best: true, title: 'Estilista Canino', company: 'Happy Friends, Estética', type: 'Temporal', typeColor: '#ba0f48' },
        { img: 'public/images/pages/jobs/logo-5.png', best: false, title: 'Recepcionista', company: 'Inntralasik', type: 'Medio tiempo', typeColor: '#f1630d' },
        { img: 'public/images/pages/jobs/logo-6.png', best: true, title: 'Arquitecto', company: 'Promso Constructora', type: 'Tiempo completo', typeColor: '#0e447b' },
        { img: 'public/images/pages/jobs/logo-7.png', best: false, title: 'Vendedor de Mostrador', company: 'Ganesh, Té de Cacao', type: 'Tiempo completo', typeColor: '#0e447b' },*/
      ],

      searchForm: {
        keywords: null,
        category: null,
        state: null,
        town:null,
        ability:null
      },
      pagination:{
        current_page:1,
        order:0,
        per_page:50,
      },
      statesOpcs:[],
      townsOpcs:[],
      categoriesOpcs:[],
      abilitiesOpcs:[]

    }
  },

  computed: {
    rows() {
      return this.jobs.length
    }
  },
  watch:{
      'searchForm.state':function(val){
          this.getTownsOpcs(val);
      },      
      searchForm: {
        handler: function(val, oldVal) {
            this.serachVacancies();
        },
        deep: true
      },
      'pagination.per_page':function(){
          this.getVacanciesCompany();
      },
      'pagination.order':function(){
          this.getVacanciesCompany();
      }     

  },
  methods:{
      serachVacancies(){
         axios.post(tools.url("/searchVacanciesCompany/"+this.id),this.searchForm)
          .then((response)=>{
              this.jobs = response.data;
          }).catch((error)=>{
              alert('Ocurrio un error en la busqueda');
          });
      },
      
      getVacanciesCompany(){
          axios.get(tools.url("/vacanciesFrontCompany/"+this.id+"/"+this.pagination.order+"/"+this.pagination.per_page+"/"+this.pagination.current_page))
          .then((response)=>{
            this.jobs = response.data.data;
            this.pagination.current_page = response.data.current_page;
            this.pagination.per_page = response.data.per_page;
            this.pagination.first_page = response.data.first_page_url;
            this.pagination.last_page = response.data.last_page;
            this.pagination.total = response.data.total;
            this.pagination.from = response.data.from;
            this.pagination.to = response.data.to;
          }).catch((error)=>{
              alert('Ocurrio un error en la busqueda');
          });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.categoriesOpcs = response.data;
          }).catch((error)=>{
            
          });
      },
      getAbilities(){
          axios.get(tools.url("/abilitiesFront"))
          .then((response)=>{
              this.abilitiesOpcs = response.data;
          }).catch((error)=>{
            
          });
      },
  },
  mounted(){

  		if(this.$route.params.id){
	        this.id=this.$route.params.id;
	        this.getVacanciesCompany();
	    }


      this.getStatesOpcs();
      this.getCategories();
      this.getAbilities();
     
  },

  components: {
    searchFormComponent
  },
}
</script>
